<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-form ref="formReciboUpdate" v-model="valid" lazy-validation @submit.prevent="saveData">
        <v-card>
          <v-card-title class="primary white--text">Recibos Disponibles a Conciliar "Cuenta Bancaria"</v-card-title>
          <v-card-text class="pa-4">
            <v-select
              v-model="cuenta"
              :items="cuentas_bancarias"
              item-text="nombre"
              outlined
              dense
              :rules="fieldRules"
              label="N° de Cuenta Bancaria"
              return-object
            ></v-select>
            <v-data-table v-if="cuenta" v-model="selected" :headers="headers" :items-per-page="-1" :items="items" :search="search" show-select>
              <template v-slot:top>
                <v-text-field dense outlined v-model="search" append-icon="mdi-magnify" label="Buscar"></v-text-field>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" rounded v-if="selected.length" color="success"> <v-icon class="mr-1"> mdi-content-save</v-icon> Actualizar </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  data() {
    return {
      api_rest: process.env.VUE_APP_API_REST,
      cuenta: null,
      search: '',
      valid: false,
      cuentas_bancarias: [],
      dialog: false,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      items: [],
      selected: [],
      headers: [
        // { text: 'ID', value: 'id', sortable: false },
        { text: 'N° comprobante', value: 'numero_comprobante' },
        { text: 'Estudiante', value: 'nombre_depositante' },
        { text: 'N° recibo', value: 'numero_recibo' },
        { text: 'Fecha De Pago', value: 'fecha_pago' },
        // { text: 'Opciones', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(sede_id, recibos) {
      // window.console.log('sede_id, recibos', sede_id, recibos);
      this.dialog = true;
      this.items = recibos;
      const sql = gql`query{getSede(id: ${sede_id}) { cuentasBancarias {id nombre nro  estado} ${''}}}`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.cuentas_bancarias = data.getSede.cuentasBancarias
          ? data.getSede.cuentasBancarias.map((c_bank) => {
              c_bank.nombre = c_bank.nombre + '  -  ' + c_bank.nro;
              return c_bank;
            })
          : [];
      });
    },
    async saveData() {
      if (this.$refs.formReciboUpdate.validate()) {
        if (await this.$root.$confirm.open('AVISO...!!!', 'Podras actualizar este dato solo una vez, estas seguro?', { color: 'red' })) {
          const url = `${this.api_rest}/api/pagos/recibos/cuenta/bancaria`;
          // FIXME: actualizar estos campos para que funcione el dato
          let formData = { recibos: this.selected.map((recibo) => recibo.id), cuenta_bancaria_id: this.cuenta.id };
          window.console.log('recibo update', url, JSON.stringify(formData));
          xaxios
            .put(url, formData)
            .then(() => {
              let forDeletion = this.selected.map((recibo) => recibo.id);
              this.items = this.items.filter((recibo) => !forDeletion.includes(recibo.id));
              this.selected = [];
            })
            .catch((error) => this.$root.$notify.show(`${error && error.response ? error.response.data.error : ''}`, { color: 'red' }));
        }
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.valid = false;
        this.cuenta = null;
        this.cuentas_bancarias = [];
        this.items = [];
        this.search = '';
        this.selected = [];
      });
    },
  },
};
</script>
